import { action, computed, makeObservable, observable, toJS } from "mobx";

export default class PatientDetailsStore {

    patientDetails = {
        name: '',
        gender: '',
        dob: '',
        contactNumber: '',
        address: '',
        isExistingPatient: false
    }
    patientSelected = false

    testDetails = {
        name: '',
        sampleType: '',
        price: ''
    }
    
    suggestedPatientResults = []
    suggestedTestResults = []

    type = ''
    selectedLab = ''
    selectedDoctor = ''
    selectedTestList = []
    
    constructor () {
        makeObservable (this, {
            patientDetails : observable,
            suggestedPatientResults :observable,
            selectedLab :observable,
            selectedDoctor :observable,
            suggestedTestResults : observable,
            selectedTestList :observable,
            patientSelected: observable,
            type :observable,

            updatePatient: action,
            updateSelectedTestList : action,
            clearSuggestedPatientResults: action,
            clearSuggestedTestResults: action,
            patientAge : computed,
            searchPatientList :action,
            searchTestList : action,
            deleteSelectedTest :action,

        });
    }

    updatePatient(patient) {
        this.patientDetails.name = patient.name;
        this.patientDetails.dob = patient.dob;
        this.patientDetails.gender = patient.gender;
        this.patientDetails.address = patient.address;
        this.patientDetails.isExistingPatient = true;
    }
    
    updateSelectedTestList(suggestedTestIndex) {
        var newSelectedTestList = toJS(this.selectedTestList);
        newSelectedTestList.push(toJS(this.suggestedTestResults[suggestedTestIndex]));

        this.selectedTestList = newSelectedTestList;
    }

    updateSelectedLab(key) {
        this.selectedLab = this.labsList[key];
    }
    
    updateSelectedDoctor(key) {
        this.selectedDoctor = this.doctorsList[key];
    }
    
    clearSuggestedPatientResults() {
        this.suggestedPatientResults = [];
    }

    clearSuggestedTestResults() {
        this.suggestedTestResults = [];
    }

    deleteSelectedTest(deleteIndex) {
        this.selectedTestList = this.selectedTestList.filter(
                (element, index) =>  deleteIndex !== index );
        console.log(this.selectedTestList.length);
    }

    clearAllSearchResults () {

        this.suggestedPatientResults = [];
        this.suggestedTestResults = [];
    }

    searchPatientList(searchText) {
   
        if(searchText == '')
        {
            return;
        }
        this.clearAllSearchResults();
        this.patientsList.map((patientDetails) => {

            if(patientDetails.name.toLowerCase().includes(searchText.toLowerCase()))
            {
                this.suggestedPatientResults.push(patientDetails);
            }
        })
    }
    
    searchTestList(searchText) {

        if(searchText == '')
        {
            return;
        }

        this.clearAllSearchResults();
        this.testsList.map((testDetails) => {

            if(testDetails.name.toLowerCase().includes(searchText.toLowerCase()))
            {
                this.suggestedTestResults.push(testDetails);
            }
        });
        console.log(this.suggestedTestResults);
    }

    get patientAge() {
        if (this.patientDetails.dob == '') return '';
        var today = new Date();
        var birthDate = new Date(this.patientDetails.dob);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        m = Math.abs(m);
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
        {
            age--;
        }
        if(age < 1)
        {
            return  m +'mo';
        }
        return age + 'Y';
    }

    labsList = [
        "Lab1", "Lab2", "Lab3"
    ]

    doctorsList = [
        "Doc1", "doc2", "doc3"
    ]

    testsList = [
        {
            name: 'Bp',
            sampleType: 'sampleBp',
            price: '100'
        },
        {
            name: 'sugar',
            sampleType: 'samplesug',
            price: '500'
        },
        {
            name: 'thyroid',
            sampleType: 'sampleThy',
            price: '100'
        },
        {
            name: 'Ecg',
            sampleType: 'sampleecg',
            price: '400'
        },
        {
            name: 'ultrasonic',
            sampleType: 'sampleultra',
            price: '800'
        },
        {
            name: 'headache',
            sampleType: 'samplehaea',
            price: '100'
        },
        {
            name: 'migrane',
            sampleType: 'samplemigp',
            price: '200'
        },
        
    ]

    patientsList = [
        {
            name: 'Patient1',
            gender: 'F',
            dob: '1990-10-10',
        },
        {
            name: 'Mariya',
            gender: 'F',
            dob: '1980-03-20'
        },
        {
            name: 'skriya',
            gender: 'F',
            dob: '1980-03-20'
        },
        {
            name: 'mehta',
            gender: 'M',
            dob: '1980-03-20'
        },
        {
            name: 'subiu',
            gender: 'M',
            dob: '1970-03-20'
        },
        {
            name: 'mehebbta',
            gender: 'F',
            dob: '1990-03-20'
        },
        {
            name: 'mehta',
            gender: 'M',
            dob: '1976-03-20'
        },
        {
            name: 'mehaefta',
            gender: 'M',
            dob: '1960-03-20'
        },
        {
            name: 'mehtrtaca',
            gender: 'M',
            dob: '1980-03-20'
        },
        {
            name: 'mesa',
            gender: 'M',
            dob: '1980-03-20'
        },
        {
            name: 'mertta',
            gender: 'M',
            dob: '1980-03-20'
        },
        {
            name: 'miuhta',
            gender: 'F',
            dob: '1980-03-20'
        },
        {
            name: 'mehnzta',
            gender: 'F',
            dob: '1980-03-20'
        }
    ]
}
